import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import MuiPagination from "../../shares/MuiPagination";
import useFetch from "../../../context/useFetch";
import { useUserData } from "../../../context/UserDataContext";
import PanelTable from "../../shares/PanelTable";
import ShowRingSizes from "./ShowRingSizes";
import AddRingTabThree from "./AddRingTabThree";
import RemoveOrderModal from "./RemoveOrderModal";
import PanelFilter from "../../shares/PanelFilter";
import { fixNumbers } from "../../../utils";

// import Others files

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "brand_name", name: "برند" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "seeـweights", name: "مشاهده وزن‌ها" },
  { colName: "delete_ring", name: "حذف" },

  { colName: "add_ring", name: "افزودن" },
];
const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
];
const dataKey = ["code", "brand_name", "show_name", "gender", "color"];

const AdminTabThree = (props) => {
  const { userData } = useUserData();
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 3000,
    count: 0,
  });
  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [ringsList, setRingsList] = useState({ results: [] });
  const GetRingsApi = useFetch({
    method: "post",
    url: `User_Service/${userData.username}/admin_get_order_item_history`,
    pagination: paginationPageInfo,
    data: {
      user: props.selectedCustomer,
      code: fixNumbers(codeFilter),
      brand: brandFilter == "all" ? null : brandFilter,
      name: nameFilter,
    },

    trigger: false,
    setter: setRingsList,
    argFunc: (res) => {
      // setPageData(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  useEffect(() => {
    if (props.selectedCustomer !== undefined) {
      GetRingsApi.reFetch();
    }
  }, [props.selectedCustomer]);

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRingsList({ results: [] });
    GetRingsApi.reFetch();
  };

  const buttonsList = [
    {
      label: "مشاهده وزن‌ها",
      component: (it) => <ShowRingSizes selectedRow={it} />,
    },
  ];
  const actionsList = [
    {
      label: "لغو سفارش",
      component: (it) => (
        <RemoveOrderModal
          selectedRow={it}
          selectedUser={props.selectedCustomer}
          GetRingsApi={GetRingsApi}
        />
      ),
    },
    {
      label: "افزودن",
      component: (it) => (
        <AddRingTabThree selectedRow={it} selectedUser={props.selectedUser} />
      ),
    },
  ];

  const filterList = [
    {
      type: "textField",
      label_fa: "کد النگو",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "نام النگو",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",

      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);
  };
  const filter = () => {
    if (codeFilter !== null || nameFilter !== null || brandFilter !== null) {
      setRingsList({ results: [] });

      GetRingsApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter(null);
    GetRingsApi.reFetch();
  };
  return (
    <>
      {props.selectedUser !== undefined ? (
        <div className="mb-4">
          <span className="text-myblue-100">
            مشتری انتخاب شده:{" "}
            <span className="text-gray-700">{props.selectedUser?.name}</span>
          </span>
        </div>
      ) : (
        ""
      )}
      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <PanelTable
        header="خریدهای قبلی:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={ringsList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AccountBalanceIcon />}
      />
      {/* <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      /> */}
    </>
  );
};

export default AdminTabThree;
